import React from 'react';
import { useTranslation } from 'react-i18next';
import { LiliButton } from '@lili/lili-frontend-common';
import Button from '../../../generic-components/Button';
import { ReactComponent as RightArrow } from '../../../assets/icons/svg/shared/ic-shared-right-arrow.svg';
import { ENROLL_STYLES_TEXTS } from '../constants';

interface IProps {
  iconSource: string;
  setForward: () => void;
}
const Enroll = ({ iconSource, setForward }: IProps) => {
  const { t } = useTranslation();
  return (
    <>
      <div className={ENROLL_STYLES_TEXTS.IMAGE_WRAPPER}>
        <img id='liliCardImage' src={iconSource} alt='myLiliCard' className={ENROLL_STYLES_TEXTS.IMAGE_CLASS_NAME} />
      </div>
      <div className={ENROLL_STYLES_TEXTS.BODY_WRAPPER}>
        <div className={ENROLL_STYLES_TEXTS.TEXTS_WRAPPER}>
          <span className={ENROLL_STYLES_TEXTS.TITLE_STYLE}>{t(ENROLL_STYLES_TEXTS.TITLE)}</span>
          <span className={ENROLL_STYLES_TEXTS.TEXT_STYLE}>
            {t(ENROLL_STYLES_TEXTS.TEXT)}
          </span>
        </div>
        <LiliButton
          id='ActivatePhysicalCard'
          title={t(ENROLL_STYLES_TEXTS.ACTIVATE_CTA_TEXT)}
          className={ENROLL_STYLES_TEXTS.ACTIVATE_CTA}
          onClick={() => {
            setForward();
          }}
        />
        <Button
          id='IDidntGetTheCard'
          title={t(ENROLL_STYLES_TEXTS.NO_CARD_CTA_TEXT)}
          className={ENROLL_STYLES_TEXTS.NO_CARD_CTA}
          childElement={<RightArrow className={ENROLL_STYLES_TEXTS.NO_CARD_CTA_ICON} />}
          onClick={() => window.open(ENROLL_STYLES_TEXTS.MAILTO, '_blank')}
        />
      </div>
    </>
  );
};

export default Enroll;
